import React from 'react'
import { Tag, message } from 'antd'
import { ThunderboltFilled, ThunderboltOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useIsSuperOrganizationScreen, useSuperOrganizationMode } from '../utils/superOrganizationMode'

// Prepinac je v hlavicke medzi oranzovymi tlacidlami - aby bol citatelny na prvy pohlad,
// je vyssi a ma plnu vypln, nie len jemny antd Tag.
const BASE_STYLE: React.CSSProperties = {
	cursor: 'pointer',
	marginRight: 16,
	userSelect: 'none',
	display: 'inline-flex',
	alignItems: 'center',
	height: 36,
	padding: '0 18px',
	fontSize: 15,
	lineHeight: '36px',
	borderRadius: 18,
	borderWidth: 1,
	borderStyle: 'solid',
	transition: 'all 0.2s'
}

const ACTIVE_STYLE: React.CSSProperties = {
	...BASE_STYLE,
	backgroundColor: '#389E0D',
	borderColor: '#389E0D',
	color: '#FFFFFF',
	fontWeight: 700,
	boxShadow: '0 2px 8px rgba(56, 158, 13, 0.35)'
}

const INACTIVE_STYLE: React.CSSProperties = {
	...BASE_STYLE,
	backgroundColor: '#FFFFFF',
	borderColor: '#8C8C8C',
	color: 'rgba(0, 0, 0, 0.75)',
	fontWeight: 600
}

/**
 * Prepinac Super Admin Mode. Zobrazuje sa len ked je rezim dostupny (obe podmienky gate-u)
 * a zaroven sme na obrazovke, kde super-org funkcia realne existuje.
 */
const SuperAdminModeTag = () => {
	const { t } = useTranslation('components')
	const { isAvailable, isActive, toggle } = useSuperOrganizationMode()
	const isSuperOrganizationScreen = useIsSuperOrganizationScreen()

	if (!isAvailable || !isSuperOrganizationScreen) {
		return null
	}

	const handleClick = () => {
		if (isActive) {
			message.info(t('components:Super Admin Mode vypnutý'))
		} else {
			message.success(t('components:Super Admin Mode zapnutý — vidíte dáta zo všetkých svojich organizácií'))
		}
		toggle()
	}

	return (
		<Tag
			onClick={handleClick}
			style={isActive ? ACTIVE_STYLE : INACTIVE_STYLE}
		>
			{isActive
				? <ThunderboltFilled style={{ marginRight: 8, fontSize: 17 }} />
				: <ThunderboltOutlined style={{ marginRight: 8, fontSize: 17 }} />}
			{isActive ? t('components:Super Admin Mode — Aktivovaný') : t('components:Super Admin Mode')}
		</Tag>
	)
}

export default SuperAdminModeTag
